import Sortable from 'sortablejs';

window.initSortableTable = _ => {
    const tableEl = document.querySelector('[data-row-reorder-enable="true"]');

    if (!tableEl) return;

    const originalOrder = [];
    const tableBody = tableEl.querySelector('tbody');
    const handle = tableEl.dataset.rowReorderSelector ?? 'tr';

    new Sortable(tableBody, {
        handle,
        easing: "cubic-bezier(1, 0, 0, 1)",
        animation: 200,
        chosenClass: 'bg-zinc-200',
        onStart: function (event) {
            tableBody.querySelectorAll('tr').forEach((row) => {
                originalOrder.push({
                    id: row.id,
                    ordem: row.dataset.ordem
                });
            });
        },
        onEnd: function (event) {
            let newOrder = [];

            tableBody.querySelectorAll('tr').forEach((row, index) => {
                newOrder.push({
                    id: row.id,
                    fromPosition: originalOrder.filter(el => el.id === row.id)[0].ordem,
                    toPosition: originalOrder[index].ordem
                });
            });

            newOrder = newOrder.filter(el => originalOrder.filter(elOri => elOri.id === el.id)[0].ordem !== el.toPosition);

            axios.put(tableEl.dataset.rowReorderUrl, { data: newOrder })
                .then(response => {
                    const data = response.data;

                    if (!data.success) {
                        throw new Error(data.message);
                    }

                    newOrder.forEach(el => {
                        document.getElementById(el.id).dataset.ordem = el.toPosition;
                    });

                    showNotification(data.message, { type: 'success' });

                })
                .catch(error => {
                    console.error(error);
                    Spinner.hide();
                    showNotification(error.message ?? 'Ocorreu um erro ao processar a requisição!', { type: 'error' });
                });
        },
    });
}

$(function () {
    initSortableTable();
});
